import React, { useState } from "react";
import { collection, getDocs, updateDoc, doc } from "firebase/firestore";
import { db } from "../FireBase"; // adjust your path

export default function FixManualTransactions() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState("");

  const fixTransactions = async () => {
    try {
      setLoading(true);
      setResult("");

      const snap = await getDocs(collection(db, "transactions"));
      let updatedCount = 0;

      for (const t of snap.docs) {
        const data = t.data();

        // Only manual payment
        if (data.paymentType === "Manual Payment") {

          // If no status field → update
          if (!data.status) {
            await updateDoc(doc(db, "transactions", t.id), {
              status: "Paid"
            });
            updatedCount++;
          }
        }
      }

      setResult(`${updatedCount} manual transactions updated.`);
    } catch (err) {
      console.error(err);
      setResult("Error occurred while updating.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h3>Fix Manual Transactions (Add Status = Paid)</h3>

      <button onClick={fixTransactions} disabled={loading}>
        {loading ? "Updating..." : "Run Fix"}
      </button>

      {result && <p>{result}</p>}
    </div>
  );
}
